import globalComponents from '../components/index'
import groupsComponents from '../components/engines/groups/index'
import styleguideComponents from '../components/shared/index'
import questionsComponents from '../components/engines/questions/index'
import engineersComponents from '../components/engines/engineers/index'
import shopComponents from '../components/engines/shop/index'
import MemberDashboard from '../components/engines/engineers/MemberDashboard'
import TutorialEditor from "../components/engines/tutorials/TutorialEditor";

export default (appSelector) => {
    let components;
    switch (appSelector) {
        case 'grabcadApp':
            components = {...globalComponents, ...styleguideComponents}
            break;
        case 'groupEditApp':
        case 'groupsApp':
            components = {...groupsComponents, ...questionsComponents, ...styleguideComponents}
            break;
        case 'questionApp':
        case 'questionEditApp':
            components = {...styleguideComponents, ...questionsComponents}
            break;
        case 'engineersApp':
        case 'engineersEdit':
            components = {...styleguideComponents, ...engineersComponents}
            break;
        case 'shopApp':
            components = {...shopComponents}
            break;
        case 'dashboardApp':
            components = { MemberDashboard }
            break;
        case 'tutorialEditorApp':
            components = { TutorialEditor }
            break;
        case 'styleguideApp':
        case 'tutorialsApp':
        case 'inboxApp':
        default:
            components = {...styleguideComponents}
            break;
    }
    return components;
}